class YaCounter {
	constructor() {}

	goal(goal) {
		console.log('Worked goal: ' + goal);
		if (typeof window['yaCounter'+App.ymId] !== 'undefined') {
			console.log('Worked goal: ' + goal);
			window['yaCounter'+App.ymId].reachGoal(goal);
		}
	}

	hits (hit) {
		hit = hit || location.href;

		if (typeof window['yaCounter'+App.ymId] !== 'undefined') {
			console.log('Worked hit: ' + hit);
			window['yaCounter'+App.ymId].hit(hit);
		}
	}
}

// click goals
let $goals = document.querySelectorAll('[data-yagoal]');
processingGoal($goals, 'yagoal', 'click');

// submit goals
let $goalsForm = document.querySelectorAll('form[data-form-yagoal]');
processingGoal($goalsForm, 'data-form-yagoal', 'submit')

function processingGoal($goals, goal, action) {
	if($goals.length) {
		let ym = new YaCounter();
		for(let i = 1; i <= $goals.length; i++) {
			if (action === 'click') {
				$goals[i -1].onclick = function () {
					let data = $(this).data(goal);
					ym.goal(data);
				};
			} else if(action === 'submit') {
				$goals[i -1].onsubmit = function () {
					let data = $(this).data(goal);
					ym.goal(data);
				};
			}
		}
	}
}

export default YaCounter;